<template>
    <div id="taxSummaryReport">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Tax Summary Report</div>
                    <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportTaxSummary()">
                        <i class="fp-export"></i> Export
                    </a>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content tax-summary-report">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <div id="dataTableFilterConfig" class="border-top-table-fl mb-3">
                            <div class="form-row row-cols-md-4 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label">Type:</label>
                                    <v-select v-model="selectedFilter" name="selectedFilter" placeholder="Select Filter Type."
                                        label="text"
                                        :options="filterOptionsArr" id="selectedFilter" @input="filterTypeChange($event)">
                                    </v-select>       
                                </div>
                                <div class="col form-group" id="selectedYearSection">
                                    <label class="control-label">Year:</label>
                                    <v-select v-model="selectedYear" name="selectedYear" placeholder="Select Year."
                                            label="text"
                                            :options="taxSummaryYearArr" id="selectedYear">
                                    </v-select>       
                                </div>    
                                <div class="col form-group date-picker-filter hide" id="filterDateRange">
                                    <label class="control-label">Date Range:</label>
                                    <v-md-date-range-picker onkeydown="return false" autocomplete="off" @change="handleChange($event)" show-year-select></v-md-date-range-picker>
                                </div>
                            </div>
                            <div class="btn-groups text-right">
                                <button type="submit" value="Search" class="btn btn-primary" v-on:click="onColumnFilter('load')">
                                    <i class="fp-search"> </i> Search
                                </button>
                                <button type="submit" class="btn btn-tertiary" v-on:click="onColumnFilter('cancel')">
                                    <i class="fp-refresh"> </i> Reset 
                                </button>
                            </div>        
                        </div>
                        <section class="bg-white">
                            <div class="table-responsive-sm">
                                <template v-if="taxSummary.length > 0">
                                    <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered purchase-order-item-table font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>&nbsp;&nbsp;&nbsp;&nbsp;</th>
                                                <template v-for="(headerData , ind) in headerArr">
                                                    <th :key="'header'+ind" class="text-right">
                                                        {{ headerData }}
                                                    </th>    
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(tax , key) in taxSummary">
                                                <tr :key="'title'+key">
                                                    <td colspan="6" class="font-bold">
                                                        {{tax.taxTitle}}
                                                    </td>    
                                                </tr>
                                                <tr :key="'sales'+key">
                                                    <td> Sales</td>
                                                    <template v-for="(salesData , ind) in tax.sales">
                                                        <td :key="'sales'+ind" class="text-right">
                                                            {{ salesData }}
                                                        </td>    
                                                    </template>
                                                </tr>
                                                <tr :key="'purchase'+key">
                                                    <td> Purchase</td>
                                                    <template v-for="(purchaseData , ind) in tax.purchase">
                                                        <td :key="'purchase'+ind" class="text-right">
                                                            {{ purchaseData }}
                                                        </td>    
                                                    </template>
                                                </tr>
                                                <tr :key="'net'+key">
                                                    <td class="font-bold"> NET </td>
                                                    <template v-for="(netData , ind) in tax.net">
                                                        <td :key="'net'+ind" class="font-bold text-right">
                                                            {{ netData }}
                                                        </td>    
                                                    </template>
                                                </tr>        
                                            </template>    
                                        </tbody>    
                                    </table>
                                </template>
                                <template v-else>
                                    <div class="lineitem-main-section">
                                        <h2 class="pl-0">No Record Found.</h2>
                                    </div>
                                </template>
                            </div>
                        </section>         
                    </div>        
                </div>    
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>    
        </div>    
    </div>    
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../../../mixins/commonMixins';
import {contractMixins} from '../../../mixins/contractMixins';
import VMdDateRangePicker from "v-md-date-range-picker";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import moment from 'moment';
Vue.use(VMdDateRangePicker);
export default {
    name: "TaxSummaryReport",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Tax Summary Report | " +process.env.COPYRIGHT_NAME
    },
    
    mixins:[commonMixins,contractMixins],
    data: () => ({
        permissions:[],
        loading:false,
        cantAccessPage:"",
        taxSummary: [],
        quarterMonths:[],
        dateFilter:{
            filterValue: null,
            filterDateValue: null
        },
        action:"list",
        filterOptionsArr:[
            {text:"Monthly",value:"month"},
            {text:"Quarterly",value:"quarter"},
            {text:"Custom",value:"custom"},
        ],
        selectedYear:"",
        selectedFilter:{text:"Quarterly",value:"quarter"},
        headerArr:[]
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'tax_summary_report') {
                    self.cantAccessPage = true;
                }
            });            
        }
    },
    created: function() {
    },
    mounted: function () {

        this.getPermissions();
        var self = this;
        setTimeout(function(){
            $("#filterDateRange .text-field").val("");   
        },300);
        var currentYear = self.getCurrentYear();
        self.selectedYear = { text : currentYear, value: currentYear}
        self.loadTaxSummary();
    },
    methods:{
        handleChange (values) {
            this.values = values;
            var selectedDateArr = [];

            for( var i=0; i<values.length; i++ ) {
                selectedDateArr[i] = values[i].format('MM/DD/YYYY');
        
            }
            this.dateFilter.filterDateValue = selectedDateArr;
        },
        filterTypeChange(evt) {
            var self = this;
            $("#filterDateRange .text-field").removeClass('border-red');
            $("#selectedYear .dropdown-toggle").removeClass('border-red');
            $("#selectedFilter .dropdown-toggle").removeClass('border-red');
            if (self.selectedFilter != null) {
                if (self.selectedFilter.value == "custom") {
                    $('#filterDateRange').removeClass("hide");
                    $("#filterDateRange .text-field").val("");
                    self.dateFilter.filterDateValue = [];
                    if (!$('#selectedYearSection').hasClass("hide")) {
                        $('#selectedYearSection').addClass("hide");
                        self.selectedYear = "";    
                    }
                }else {
                    if (!$('#filterDateRange').hasClass("hide")) {
                        $('#filterDateRange').addClass("hide");
                        $("#filterDateRange .text-field").val("");
                        self.dateFilter.filterDateValue = [];
                    }
                    $('#selectedYearSection').removeClass("hide");
                    var currentYear = self.getCurrentYear();
                    self.selectedYear = { text : currentYear, value: currentYear}
                }
            }else{
                if (!$('#filterDateRange').hasClass("hide")) {
                    $('#filterDateRange').addClass("hide");
                    $("#filterDateRange .text-field").val("");
                    self.dateFilter.filterDateValue = [];
                }
                if ($('#selectedYearSection').hasClass("hide")) {
                    $('#selectedYearSection').removeClass("hide");
                    var currentYear = self.getCurrentYear();
                    self.selectedYear = { text : currentYear, value: currentYear}
                }
            }
        },
        loadTaxSummary() {
            var self = this;
            self.loading = true;

            if (self.selectedFilter.value == "custom") {
                var fields = {
                    year:self.selectedYear.value,
                    filterType:self.selectedFilter.value,
                    dateRange:self.dateFilter.filterDateValue,
                    action:self.action
                };
            }else{
                var fields = {
                    year:self.selectedYear.value,
                    filterType:self.selectedFilter.value,
                    action:self.action
                };
            }
            
            // fields.push({name:"filters",value:JSON.stringify(self.filtersArr)});
            $.ajax({
                url: process.env.ROOT_API + "/accounting/reports/tax-summary",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {
                        if (self.action =='export'){

                            self.action = 'list';
                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {

                                self.excel = data.content.web;
                                var save = document.createElement("a");
                                save.href = self.excel;
                                save.download = data.content.web;
                                save.target = "_blank";

                                document.body.appendChild(save);
                                save.click();
                                document.body.removeChild(save);
                            }
                        }else{
                            self.taxSummary = data.content.summary;
                            self.headerArr = data.content.header;
                        }
                    }else{
                        self.$swal('',data.message,'info');
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'tax-summary-report');
                }
            });
        },
        checkFilterValidation: function() {
            var self = this;
            var error = false;

            if (self.selectedFilter != null) {
                if (self.selectedFilter.value == "custom") {
                    if (self.dateFilter.filterDateValue == null || self.dateFilter.filterDateValue == "" || !self.dateFilter.filterDateValue) {
                        $("#filterDateRange .text-field").addClass('border-red');
                        error = true;
                    }else{
                        $("#filterDateRange .text-field").removeClass('border-red');    
                    }
                }else{
                    if (self.selectedYear == null || self.selectedYear.value == "") {
                        $("#selectedYear .dropdown-toggle").addClass('border-red');
                        error = true;
                    }else{
                        $("#selectedYear .dropdown-toggle").removeClass('border-red');
                    }
                }
            }

            if (self.selectedFilter == null || self.selectedFilter.value == "") {
                $("#selectedFilter .dropdown-toggle").addClass('border-red');
                error = true;
            }else{
                $("#selectedFilter .dropdown-toggle").removeClass('border-red');
            }

            return error;
        },
        onColumnFilter(flag) {
            var self = this;
            if ( flag == 'load' ) {
                var error = false;
                error = self.checkFilterValidation();
                if (!error) {
                    self.loadTaxSummary();
                }
            }else{
                setTimeout(function(){                   
                    $("#filterDateRange .text-field").val("");
                    $("#filterDateRange .text-field").removeClass('border-red');
                    $("#selectedYear .dropdown-toggle").removeClass('border-red');
                    $("#selectedFilter .dropdown-toggle").removeClass('border-red');
                    $('#filterDateRange').addClass("hide");
                    if ($('#selectedYearSection').hasClass("hide")) {
                        $('#selectedYearSection').removeClass("hide");
                    }
                },200);

                self.dateFilter = {filterValue: null,filterDateValue: null};
                var currentYear = self.getCurrentYear();
                self.selectedYear = { text : currentYear, value: currentYear};
                self.selectedFilter = {text:"Quarterly",value:"quarter"};
                self.loadTaxSummary();
            }
        },
        getCurrentYear() {
            var today = new Date();
            var yyyy = today.getFullYear();
            return yyyy.toString();
        },
        exportTaxSummary() {
            var self = this;
            this.action = "export";
            this.loadTaxSummary();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/accounting/reports/TaxSummaryReport.vue